export default __webpack_public_path__ + "static/media/reports.b3ad8cb6.svg";